import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { DocumentoUICamViewModel } from './unidad-inspeccion-datosbasicos.types';

@Injectable()
export class DocumentoUiService {
    private docUiCamEndpoint = this.baseUrl + 'api/campanias/documentoUiCam/';
    private fileEndpoint = this.baseUrl + 'api/core/camDoc/';

    constructor(
        private http: HttpClient,
        @Inject('BASE_URL') private baseUrl: string,
    ) {}

    getDocumentoById(id: number): Observable<DocumentoUICamViewModel> {
        return this.http.get<DocumentoUICamViewModel>(this.docUiCamEndpoint + id);
    }

    getDocumentosByIdUi(idUi: number): Observable<DocumentoUICamViewModel[]> {
        return this.http.get<DocumentoUICamViewModel[]>(this.docUiCamEndpoint + 'list/' + idUi);
    }

    save(documentoUiCam: DocumentoUICamViewModel): Observable<any> {
        if (documentoUiCam) {
            return this.http.post<DocumentoUICamViewModel>(this.docUiCamEndpoint + 'persistDoc/', documentoUiCam);
        }
        return of(null);
    }

    saveDocumentos(documentosUiCam: DocumentoUICamViewModel[]): Observable<any> {
        if (documentosUiCam?.length > 0) {
            return this.http.post<DocumentoUICamViewModel[]>(this.docUiCamEndpoint, documentosUiCam);
        }
        return of(null);
    }

    deleteDocumentos(idsDocsUiCamList: (number | null | undefined)[]): Observable<any> {
        if (idsDocsUiCamList?.length > 0) {
            return this.http.post<DocumentoUICamViewModel[]>(this.docUiCamEndpoint + 'deleteDocs/', idsDocsUiCamList);
        }
        return of(null);
    }

    deleteFile(guid: string): Observable<any> {
        return this.http.delete<string>(this.fileEndpoint + guid);
    }
}
